import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import { LoaderProps } from './types';

const Loader = ({ fullScreen, size }: LoaderProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={fullScreen ? '100vh' : '100%'}
    >
      <CircularProgress size={fullScreen ? 75 : size} />
    </Box>
  );
};

export default Loader;
